/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '@angular/forms';
import * as import3 from '../../../app/checkout/checkout-vm.component';
import * as import4 from '../../../app/services/api.service';
import * as import5 from '../../../app/services/cart.service';
import * as import6 from 'angular2-notifications/src/notifications.service';
import * as import7 from '@ngx-translate/core/src/translate.service';
import * as import8 from '@angular/router';
const styles_CheckoutVMComponent:any[] = ([] as any[]);
export const RenderType_CheckoutVMComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CheckoutVMComponent,
  data: {}
}
);
function View_CheckoutVMComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            Wybrany dysk:\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.default_disk.name;
    ck(v,3,0,currVal_0);
  });
}
function View_CheckoutVMComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ', '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,1,0,currVal_0);
  });
}
function View_CheckoutVMComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            Usługi Dodatkowe:\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_4)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.additional_services;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CheckoutVMComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' ',
      ' GB, '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.diskType.name;
    const currVal_1:any = v.context.$implicit.value;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CheckoutVMComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            Dodatkowe przestrzenie dyskowe:\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_6)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.additional_storages;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CheckoutVMComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),35,'div',[[
        'class',
        'vm-list__shopping-cart-item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__shopping-cart-item-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'vm-list__shopping-cart-item-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'vm-list__shopping-cart-item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'vm-list__shopping-cart-item-button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.removeCartItem(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['-'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'vm-list__shopping-cart-item-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      'vCPU, ',
      'vRAM, ',
      'MBit/s\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            System: ',
      ' ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'vm-list__shopping-cart-item-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      ' zł/mies.\n                        '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_6:any = v.context.$implicit.default_disk;
    ck(v,23,0,currVal_6);
    const currVal_7:any = (v.context.$implicit.additional_services.length > 0);
    ck(v,26,0,currVal_7);
    const currVal_8:any = (v.context.$implicit.additional_storages.length > 0);
    ck(v,29,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.configuration.name;
    ck(v,7,0,currVal_0);
    const currVal_1:any = v.context.$implicit.processors;
    const currVal_2:any = v.context.$implicit.ram;
    const currVal_3:any = v.context.$implicit.public_network_speed;
    ck(v,17,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = v.context.$implicit.selected_os.type.name;
    const currVal_5:any = v.context.$implicit.selected_os.name;
    ck(v,20,0,currVal_4,currVal_5);
    const currVal_9:any = import0.ɵunv(v,32,0,ck(v,33,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.netto));
    ck(v,32,0,currVal_9);
  });
}
function View_CheckoutVMComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.loadConfigurations(v.context.$implicit,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-types-button',
      'vm-list__vm-types-button-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,true,(v.context.$implicit.uuid === co.selectedConfigurationType.uuid));
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.name;
    ck(v,3,0,currVal_1);
  });
}
function View_CheckoutVMComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__vm-types-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__vm-types-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__vm-types-buttons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_8)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit.configuration_types;
    ck(v,8,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_CheckoutVMComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),63,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-element',
      'vm-list__vm-list-element-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),52,'div',[[
        'class',
        'vm-list__vm-list-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__vm-list-parameter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-icon',
      'vm-list__vm-list-parameter-icon-processor',
      'vm-list__vm-list-parameter-icon-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-text',
      'vm-list__vm-list-parameter-text-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '',
      ' x ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'vm-list__vm-list-parameter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-icon',
      'vm-list__vm-list-parameter-icon-ram',
      'vm-list__vm-list-parameter-icon-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-text',
      'vm-list__vm-list-parameter-text-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '',
      ' GB'
    ]
    )),
    import0.ɵppd(1),
    import0.ɵppd(1),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__vm-list-parameter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-icon',
      'vm-list__vm-list-parameter-icon-disk',
      'vm-list__vm-list-parameter-icon-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-text',
      'vm-list__vm-list-parameter-text-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__vm-list-parameter'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-icon',
      'vm-list__vm-list-parameter-icon-network',
      'vm-list__vm-list-parameter-icon-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-parameter-text',
      'vm-list__vm-list-parameter-text-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '',
      ' Mbit/s'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectConfiguration(v.context.$implicit,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpod([
      'vm-list__vm-list-button',
      'vm-list__vm-list-button-selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '',
      ' zł/mies.'
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,1,0,currVal_0);
    const currVal_1:any = ck(v,10,0,true,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,9,0,currVal_1);
    const currVal_2:any = ck(v,14,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,13,0,currVal_2);
    const currVal_5:any = ck(v,22,0,true,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,21,0,currVal_5);
    const currVal_6:any = ck(v,26,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,25,0,currVal_6);
    const currVal_8:any = ck(v,37,0,true,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,36,0,currVal_8);
    const currVal_9:any = ck(v,41,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,40,0,currVal_9);
    const currVal_11:any = ck(v,49,0,true,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,48,0,currVal_11);
    const currVal_12:any = ck(v,53,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,52,0,currVal_12);
    const currVal_14:any = ck(v,60,0,true,(v.context.$implicit.uuid === co.selectedConfiguration.uuid));
    ck(v,59,0,currVal_14);
  },(ck,v) => {
    const currVal_3:any = (((v.context.$implicit.min_processor_count == v.context.$implicit.processors) && (v.context.$implicit.processors == v.context.$implicit.max_processor_count))? v.context.$implicit.processors: ((v.context.$implicit.min_processor_count + ' - ') + v.context.$implicit.max_processor_count));
    const currVal_4:any = v.context.$implicit.processor.name;
    ck(v,15,0,currVal_3,currVal_4);
    const currVal_7:any = (((v.context.$implicit.min_ram_size == v.context.$implicit.ram_size) && (v.context.$implicit.ram_size == v.context.$implicit.max_ram_size))? import0.ɵunv(v,27,0,ck(v,28,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.ram_size)): ((import0.ɵunv(v,27,0,ck(v,29,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.min_ram_size)) + ' - ') + import0.ɵunv(v,27,0,ck(v,30,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.max_ram_size))));
    ck(v,27,0,currVal_7);
    const currVal_10:any = v.context.$implicit.disk_size.name;
    ck(v,42,0,currVal_10);
    const currVal_13:any = v.context.$implicit.public_network_speed;
    ck(v,54,0,currVal_13);
    const currVal_15:any = ((v.context.$implicit.configurable == true)? 'od ': '');
    const currVal_16:any = import0.ɵunv(v,61,1,ck(v,62,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.netto));
    ck(v,61,0,currVal_15,currVal_16);
  });
}
function View_CheckoutVMComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'vm-list__vm-configuration-checkbox-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'vm-list__vm-configuration-checkbox'
      ]
      ,
      [
        'name',
        'radio-additional-disk'
      ]
      ,
      [
        'type',
        'radio'
      ]

    ]
    ,[
      [
        8,
        'id',
        0
      ]
      ,
      [
        1,
        'value',
        0
      ]

    ]
      ,[[
        (null as any),
        'change'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>co.setAdditionalDisk(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'additional_disk_',v.context.$implicit.uuid,'');
    const currVal_1:any = v.context.$implicit.uuid;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = v.context.$implicit.name;
    ck(v,3,0,currVal_2);
  });
}
function View_CheckoutVMComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),91,'div',[[
        'class',
        'vm-list__vm-configuration-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),88,'div',[[
        'class',
        'vm-list__vm-configuration'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'vm-list__vm-configuration-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'vm-list__vm-configuration-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'class',
        'vm-list__vm-configuration-slider'
      ]
      ,
      [
        'id',
        'range'
      ]
      ,
      [
        'name',
        'range'
      ]
      ,
      [
        'type',
        'range'
      ]

    ]
    ,[
      [
        1,
        'min',
        0
      ]
      ,
      [
        1,
        'max',
        0
      ]
      ,
      [
        1,
        'value',
        0
      ]
      ,
      [
        1,
        'step',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,12)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,12).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,12)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,12)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,13).onChange($event.target.value)) !== false);
        ad = (pd_4 && ad);
      }
      if (('input' === en)) {
        const pd_5:any = ((<any>import0.ɵnov(v,13).onChange($event.target.value)) !== false);
        ad = (pd_5 && ad);
      }
      if (('blur' === en)) {
        const pd_6:any = ((<any>import0.ɵnov(v,13).onTouched()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(co.processorsSelected = $event)) !== false);
        ad = (pd_7 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_8:any = ((<any>co.setProcessors($event)) !== false);
        ad = (pd_8 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import2.ɵbe,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.DefaultValueAccessor,
      import2.ɵbe
    ]
    ),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['              \n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        + ',
      ' zł/mies.\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'vm-list__vm-configuration-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        vRAM\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'vm-list__vm-configuration-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'class',
        'vm-list__vm-configuration-slider'
      ]
      ,
      [
        'id',
        'range'
      ]
      ,
      [
        'name',
        'range'
      ]
      ,
      [
        'type',
        'range'
      ]

    ]
    ,[
      [
        1,
        'min',
        0
      ]
      ,
      [
        1,
        'max',
        0
      ]
      ,
      [
        1,
        'value',
        0
      ]
      ,
      [
        1,
        'step',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,35)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,35).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,35)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,35)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,36).onChange($event.target.value)) !== false);
        ad = (pd_4 && ad);
      }
      if (('input' === en)) {
        const pd_5:any = ((<any>import0.ɵnov(v,36).onChange($event.target.value)) !== false);
        ad = (pd_5 && ad);
      }
      if (('blur' === en)) {
        const pd_6:any = ((<any>import0.ɵnov(v,36).onTouched()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(co.ramSelected = $event)) !== false);
        ad = (pd_7 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_8:any = ((<any>co.setRam($event)) !== false);
        ad = (pd_8 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import2.ɵbe,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.DefaultValueAccessor,
      import2.ɵbe
    ]
    ),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['      \n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      ' GB\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        + ',
      ' zł/mies.\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'vm-list__vm-configuration-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        Sieć publiczna\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'vm-list__vm-configuration-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'class',
        'vm-list__vm-configuration-slider'
      ]
      ,
      [
        'id',
        'range'
      ]
      ,
      [
        'name',
        'range'
      ]
      ,
      [
        'type',
        'range'
      ]

    ]
    ,[
      [
        1,
        'min',
        0
      ]
      ,
      [
        1,
        'max',
        0
      ]
      ,
      [
        1,
        'value',
        0
      ]
      ,
      [
        1,
        'step',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,58)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,58).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,58)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,58)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,59).onChange($event.target.value)) !== false);
        ad = (pd_4 && ad);
      }
      if (('input' === en)) {
        const pd_5:any = ((<any>import0.ɵnov(v,59).onChange($event.target.value)) !== false);
        ad = (pd_5 && ad);
      }
      if (('blur' === en)) {
        const pd_6:any = ((<any>import0.ɵnov(v,59).onTouched()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(co.speedSelected = $event)) !== false);
        ad = (pd_7 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_8:any = ((<any>co.setSpeed($event)) !== false);
        ad = (pd_8 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import2.ɵbe,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.DefaultValueAccessor,
      import2.ɵbe
    ]
    ),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['      \n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      ' Mbit/s\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        + ',
      ' zł/mies.\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'vm-list__vm-configuration-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        Dysk\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__vm-configuration-checkboxes'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_11)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-value'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__vm-configuration-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        + ',
      ' zł/mies.\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            \n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_12:any = 'range';
    const currVal_13:any = co.processorsSelected;
    ck(v,15,0,currVal_12,currVal_13);
    const currVal_27:any = 'range';
    const currVal_28:any = co.ramSelected;
    ck(v,38,0,currVal_27,currVal_28);
    const currVal_42:any = 'range';
    const currVal_43:any = co.speedSelected;
    ck(v,61,0,currVal_42,currVal_43);
    const currVal_46:any = co.selectedConfiguration.disk_sizes;
    ck(v,81,0,currVal_46);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedConfiguration.processor.name;
    ck(v,7,0,currVal_0);
    const currVal_1:any = co.selectedConfiguration.min_processor_count;
    const currVal_2:any = co.selectedConfiguration.max_processor_count;
    const currVal_3:any = co.selectedConfiguration.processors;
    const currVal_4:any = co.selectedConfiguration.processor_step;
    const currVal_5:any = import0.ɵnov(v,17).ngClassUntouched;
    const currVal_6:any = import0.ɵnov(v,17).ngClassTouched;
    const currVal_7:any = import0.ɵnov(v,17).ngClassPristine;
    const currVal_8:any = import0.ɵnov(v,17).ngClassDirty;
    const currVal_9:any = import0.ɵnov(v,17).ngClassValid;
    const currVal_10:any = import0.ɵnov(v,17).ngClassInvalid;
    const currVal_11:any = import0.ɵnov(v,17).ngClassPending;
    ck(v,11,1,[
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11
    ]
    );
    const currVal_14:any = co.processorsSelected;
    ck(v,21,0,currVal_14);
    const currVal_15:any = co.nettoPerSelectedProcessors;
    ck(v,24,0,currVal_15);
    const currVal_16:any = co.selectedConfiguration.min_ram_size;
    const currVal_17:any = co.selectedConfiguration.max_ram_size;
    const currVal_18:any = co.selectedConfiguration.ram_size;
    const currVal_19:any = co.selectedConfiguration.ram_size_step;
    const currVal_20:any = import0.ɵnov(v,40).ngClassUntouched;
    const currVal_21:any = import0.ɵnov(v,40).ngClassTouched;
    const currVal_22:any = import0.ɵnov(v,40).ngClassPristine;
    const currVal_23:any = import0.ɵnov(v,40).ngClassDirty;
    const currVal_24:any = import0.ɵnov(v,40).ngClassValid;
    const currVal_25:any = import0.ɵnov(v,40).ngClassInvalid;
    const currVal_26:any = import0.ɵnov(v,40).ngClassPending;
    ck(v,34,1,[
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
    const currVal_29:any = co.ramSelected;
    ck(v,44,0,currVal_29);
    const currVal_30:any = co.nettoPerSelectedRamSize;
    ck(v,47,0,currVal_30);
    const currVal_31:any = co.selectedConfiguration.min_public_network_speed;
    const currVal_32:any = co.selectedConfiguration.max_public_network_speed;
    const currVal_33:any = co.selectedConfiguration.public_network_speed;
    const currVal_34:any = co.selectedConfiguration.public_network_speed_step;
    const currVal_35:any = import0.ɵnov(v,63).ngClassUntouched;
    const currVal_36:any = import0.ɵnov(v,63).ngClassTouched;
    const currVal_37:any = import0.ɵnov(v,63).ngClassPristine;
    const currVal_38:any = import0.ɵnov(v,63).ngClassDirty;
    const currVal_39:any = import0.ɵnov(v,63).ngClassValid;
    const currVal_40:any = import0.ɵnov(v,63).ngClassInvalid;
    const currVal_41:any = import0.ɵnov(v,63).ngClassPending;
    ck(v,57,1,[
      currVal_31,
      currVal_32,
      currVal_33,
      currVal_34,
      currVal_35,
      currVal_36,
      currVal_37,
      currVal_38,
      currVal_39,
      currVal_40,
      currVal_41
    ]
    );
    const currVal_44:any = co.speedSelected;
    ck(v,67,0,currVal_44);
    const currVal_45:any = co.nettoPerSelectedSpeed;
    ck(v,70,0,currVal_45);
    const currVal_47:any = co.nettoPerSelectedAdditionalDisks;
    ck(v,88,0,currVal_47);
  });
}
function View_CheckoutVMComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[[
        'class',
        'vm-list__additional-disk-option'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import2.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import2.SelectControlValueAccessor
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import2.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '\n                                ',
      '\n                            '
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
    const currVal_1:any = v.context.$implicit;
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit.name;
    ck(v,3,0,currVal_2);
  });
}
function View_CheckoutVMComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'vm-list__additional-disk-slider-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__additional-disk-slider-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'class',
        'vm-list__additional-disk-slider'
      ]
      ,
      [
        'type',
        'range'
      ]

    ]
    ,[
      [
        8,
        'id',
        0
      ]
      ,
      [
        1,
        'min',
        0
      ]
      ,
      [
        1,
        'max',
        0
      ]
      ,
      [
        1,
        'value',
        0
      ]
      ,
      [
        1,
        'step',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'change'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,6)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,6).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,6)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,6)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('change' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,7).onChange($event.target.value)) !== false);
        ad = (pd_4 && ad);
      }
      if (('input' === en)) {
        const pd_5:any = ((<any>import0.ɵnov(v,7).onChange($event.target.value)) !== false);
        ad = (pd_5 && ad);
      }
      if (('blur' === en)) {
        const pd_6:any = ((<any>import0.ɵnov(v,7).onTouched()) !== false);
        ad = (pd_6 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_7:any = ((<any>(v.context.$implicit.value = $event)) !== false);
        ad = (pd_7 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_8:any = ((<any>co.setAdditionalStorageValue(v.context.$implicit,$event)) !== false);
        ad = (pd_8 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import2.ɵbe,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.DefaultValueAccessor,
      import2.ɵbe
    ]
    ),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__additional-disk-slider-size-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' GB'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'h5',[[
        'class',
        'vm-list__additional-disk-slider-netto-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '+ ',
      ' zł/mies.'
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_13:any = v.context.$implicit.value;
    ck(v,9,0,currVal_13);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.diskType.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵinlineInterpolate(1,'additional_storage_',co.selectedAdditionalStorageDiskType.uuid,'');
    const currVal_2:any = v.context.$implicit.diskType.pivot.min_disk_size;
    const currVal_3:any = v.context.$implicit.diskType.pivot.max_disk_size;
    const currVal_4:any = v.context.$implicit.diskType.pivot.disk_size;
    const currVal_5:any = v.context.$implicit.diskType.pivot.step;
    const currVal_6:any = import0.ɵnov(v,11).ngClassUntouched;
    const currVal_7:any = import0.ɵnov(v,11).ngClassTouched;
    const currVal_8:any = import0.ɵnov(v,11).ngClassPristine;
    const currVal_9:any = import0.ɵnov(v,11).ngClassDirty;
    const currVal_10:any = import0.ɵnov(v,11).ngClassValid;
    const currVal_11:any = import0.ɵnov(v,11).ngClassInvalid;
    const currVal_12:any = import0.ɵnov(v,11).ngClassPending;
    ck(v,5,1,[
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12
    ]
    );
    const currVal_14:any = v.context.$implicit.value;
    ck(v,14,0,currVal_14);
    const currVal_15:any = import0.ɵunv(v,17,0,ck(v,18,0,import0.ɵnov((<any>v.parent),0),v.context.$implicit.netto));
    ck(v,17,0,currVal_15);
  });
}
function View_CheckoutVMComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[[
        'class',
        'vm-list__operating-system-option'
      ]
      ],[[
        1,
        'selected',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import2.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import2.SelectControlValueAccessor
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import2.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '\n                                ',
      ' ',
      '\n                                '
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit;
    ck(v,1,0,currVal_1);
    const currVal_2:any = v.context.$implicit;
    ck(v,2,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.selectedOperatingSystem.uuid === v.context.$implicit.uuid);
    ck(v,0,0,currVal_0);
    const currVal_3:any = v.context.$implicit.type.name;
    const currVal_4:any = v.context.$implicit.name;
    ck(v,3,0,currVal_3,currVal_4);
  });
}
function View_CheckoutVMComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'vm-list__operating-system-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'vm-list__operating-system-logo-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'vm-list__operating-system-logo'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__operating-system-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'vm-list__operating-system-version-select-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'select',[
      [
        'class',
        'vm-list__operating-system-select'
      ]
      ,
      [
        'name',
        'operating-system'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,13).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,13).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>(co.selectedOperatingSystem = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_3:any = ((<any>co.setOperatingSystem($event)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_15)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = 'operating-system';
    const currVal_10:any = co.selectedOperatingSystem;
    ck(v,15,0,currVal_9,currVal_10);
    const currVal_11:any = v.context.$implicit.operating_systems;
    ck(v,20,0,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit.imgsrc,'');
    ck(v,4,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    ck(v,8,0,currVal_1);
    const currVal_2:any = import0.ɵnov(v,17).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,17).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,17).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,17).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,17).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,17).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,17).ngClassPending;
    ck(v,12,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_CheckoutVMComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'vm-list__additional-service-element'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'vm-list__additional-service-checkbox-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'vm-list__additional-service-checkbox'
      ]
      ,
      [
        'type',
        'checkbox'
      ]

    ]
      ,[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'change'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>co.setAdditionalService(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__additional-service-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__additional-service-text-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__additional-service-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' ',
      ' zł/mies.'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__additional-service-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'additional_service_',v.context.$implicit.uuid,'');
    ck(v,4,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    const currVal_2:any = v.context.$implicit.netto;
    ck(v,12,0,currVal_1,currVal_2);
    const currVal_3:any = v.context.$implicit.description;
    ck(v,16,0,currVal_3);
  });
}
export function View_CheckoutVMComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import1.DecimalPipe,[import0.LOCALE_ID]),
      (l()(),import0.ɵeld(0,(null as any),(null as any),141,'div',[[
        'class',
        'vm-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),29,'div',[[
        'class',
        'vm-list__shopping-cart-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'vm-list__shopping-cart'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__shopping-cart-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twoje konfiguracje'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__shopping-cart-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_1)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__shopping-cart-monthly-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Opłata miesięczna'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'vm-list__shopping-cart-netto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' zł'
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vm-list__shopping-cart-contract-length-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Umowa na 24 miesiące'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__shopping-cart-button-finalize-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'vm-list__shopping-cart-button-finalize'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.CheckoutVMComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.addItemsToCart()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    Uzupełnij dane\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'vm-list__title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wybierz konfigurację'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h5',[[
        'class',
        'vm-list__description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Skorzystaj z gotowych rozwiązań lub przygotuj własne.'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'vm-list__vm-types-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__vm-types'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_7)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__vm-list-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__vm-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            \n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_9)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n           \n\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_10)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),44,'div',[[
        'class',
        'vm-list__additional-disk-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),41,'div',[[
        'class',
        'vm-list__additional-disk'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'vm-list__additional-disk-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Potrzebujesz więcej przestrzeni dyskowej?'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),35,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'vm-list__additional-disk-select-and-button-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'vm-list__additional-disk-select-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),14,'select',[
      [
        'class',
        'vm-list__additional-disk-select'
      ]
      ,
      [
        'name',
        'additional-disk'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.CheckoutVMComponent = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,75).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,75).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>(co.selectedAdditionalStorageDiskType = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_3:any = ((<any>co.setAdditionalStorageDiskType($event)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      isDisabled: [
        1,
        'isDisabled'
      ]
      ,
      model: [
        2,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',[
      [
        'disabled',
        ''
      ]
      ,
      [
        'selected',
        ''
      ]
      ,
      [
        'value',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import2.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import2.SelectControlValueAccessor
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import2.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{value: [
        0,
        'value'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[' -- Wybierz typ -- '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_12)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__additional-disk-button-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'vm-list__additional-disk-button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.CheckoutVMComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.addAdditionalStorage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Dodaj ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__additional-disk-sliders-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_13)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'vm-list__operating-system-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__operating-system'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'vm-list__operating-system-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wybierz system do zainstalowania na serwerze'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__operating-system-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_14)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'vm-list__additional-service-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'vm-list__additional-service'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'vm-list__additional-service-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wybierz dodatkowe usługi'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__additional-service-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutVMComponent_16)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'vm-list__button-add-to-cart-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'vm-list__button-add-to-cart'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.CheckoutVMComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.addToCart()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dodaj do koszyka'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    \n']))
  ]
  ,(ck,v) => {
    var co:import3.CheckoutVMComponent = v.component;
    const currVal_0:any = co.checkoutCartItems;
    ck(v,13,0,currVal_0);
    const currVal_2:any = co.configurationGroups;
    ck(v,45,0,currVal_2);
    const currVal_3:any = co.configurations;
    ck(v,54,0,currVal_3);
    const currVal_4:any = co.selectedConfiguration.configurable;
    ck(v,58,0,currVal_4);
    const currVal_12:any = 'additional-disk';
    const currVal_13:any = (co.selectedConfiguration.processors == 0);
    const currVal_14:any = co.selectedAdditionalStorageDiskType;
    ck(v,77,0,currVal_12,currVal_13,currVal_14);
    const currVal_15:any = '';
    ck(v,82,0,currVal_15);
    const currVal_16:any = '';
    ck(v,83,0,currVal_16);
    const currVal_17:any = co.additionalStorages;
    ck(v,87,0,currVal_17);
    const currVal_19:any = co.selectedAdditionalStorages;
    ck(v,101,0,currVal_19);
    const currVal_20:any = co.operatingSystemTypes;
    ck(v,117,0,currVal_20);
    const currVal_21:any = co.additionalServices;
    ck(v,132,0,currVal_21);
  },(ck,v) => {
    var co:import3.CheckoutVMComponent = v.component;
    const currVal_1:any = import0.ɵunv(v,20,0,ck(v,21,0,import0.ɵnov(v,0),co.nettoSum));
    ck(v,20,0,currVal_1);
    const currVal_5:any = import0.ɵnov(v,79).ngClassUntouched;
    const currVal_6:any = import0.ɵnov(v,79).ngClassTouched;
    const currVal_7:any = import0.ɵnov(v,79).ngClassPristine;
    const currVal_8:any = import0.ɵnov(v,79).ngClassDirty;
    const currVal_9:any = import0.ɵnov(v,79).ngClassValid;
    const currVal_10:any = import0.ɵnov(v,79).ngClassInvalid;
    const currVal_11:any = import0.ɵnov(v,79).ngClassPending;
    ck(v,74,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_18:any = ((co.selectedAdditionalStorages.length > 0)? 'kolejną': '');
    ck(v,94,0,currVal_18);
  });
}
function View_CheckoutVMComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'vm-list',([] as any[]),(null as any),(null as any),(null as any),View_CheckoutVMComponent_0,RenderType_CheckoutVMComponent)),
    import0.ɵdid(114688,(null as any),0,import3.CheckoutVMComponent,[
      import4.ApiService,
      import5.CartService,
      import6.NotificationsService,
      import7.TranslateService,
      import8.ActivatedRoute
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CheckoutVMComponentNgFactory:import0.ComponentFactory<import3.CheckoutVMComponent> = import0.ɵccf('vm-list',import3.CheckoutVMComponent,View_CheckoutVMComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/checkout/checkout-vm.component.ngfactory.ts